(function(){
  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    document.documentElement.classList.add('pg-farma-enhanced');
    var labels = {
      'integratori': '+',
      'farmaci': 'RX',
      'farmaci da banco': 'RX',
      'cosmetica': 'DERM',
      'igiene': 'SAFE',
      'veterinaria': 'PET',
      'rimedi per': '?',
      'offerte': '%'
    };
    document.querySelectorAll('.header-04 .header__menu-vertical .menu-lv-1__action').forEach(function(link){
      var text = (link.textContent || '').trim().toLowerCase();
      if(link.querySelector('.pg-menu-badge')) return;
      var icon = '+';
      Object.keys(labels).some(function(key){ if(text.indexOf(key) !== -1){ icon = labels[key]; return true; } return false; });
      var badge = document.createElement('span');
      badge.className = 'pg-menu-badge';
      badge.textContent = icon;
      badge.setAttribute('aria-hidden','true');
      link.insertBefore(badge, link.firstChild);
    });
  });
})();

(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    document.querySelectorAll('.template-product .productView-nav:not(.slick-initialized), .template-product .productView-for:not(.slick-initialized)').forEach(function(gallery){
      var slides = Array.prototype.slice.call(gallery.children || []);
      if(slides.length > 1){
        gallery.classList.add('pg-horizontal-product-gallery');
        slides.forEach(function(slide){ slide.classList.add('pg-horizontal-product-slide'); });
      }
    });
  });
  ready(function(){
    var rte = document.querySelector('body.template-page .section-page rte-formatter');
    if(!rte || document.querySelector('.block-contact-form')) return;
    var heads = Array.prototype.slice.call(rte.querySelectorAll('h2'));
    if(heads.length < 4) return;
    var nav = document.createElement('nav');
    nav.className = 'pg-page-toc';
    nav.setAttribute('aria-label', 'Indice della pagina');
    var html = '<strong>In questa pagina</strong><ol>';
    heads.forEach(function(h, i){
      if(!h.id) h.id = 'pg-sezione-' + (i + 1);
      var a = document.createElement('span'); a.textContent = h.textContent;
      html += '<li><a href="#' + h.id + '">' + a.innerHTML + '</a></li>';
    });
    nav.innerHTML = html + '</ol>';
    var first = heads[0];
    first.parentNode.insertBefore(nav, first);
  });
})();
